// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__dI50D","anticon":"Modal_anticon__5VRUx"};